import React from "react"

const LoginContext = React.createContext(null)

export default LoginContext
